var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_reply",
    transform: "translate(-232 -664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_1892",
    "data-name": "\\uC0AC\\uAC01\\uD615 1892",
    transform: "translate(232 664)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1806",
    "data-name": "\\uADF8\\uB8F9 1806",
    transform: "translate(-44.331 -251.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_686",
    "data-name": "\\uD328\\uC2A4 686",
    d: "M11632.77-9961.543v2.486c0,2.381,2.064,5.82,5.291,5.82h7.514",
    transform: "translate(-11351 10882)",
    fill: "none",
    stroke: "#386a98",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_687",
    "data-name": "\\uD328\\uC2A4 687",
    d: "M11649.726-9953.3l3.758,3.757-3.758,3.757",
    transform: "translate(-11358.591 10878.311)",
    fill: "none",
    stroke: "#386a98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReply);
export default __webpack_public_path__ + "static/media/ico_reply.8ef2c755c35e396fb693c3b36a3132c2.svg";
export { ForwardRef as ReactComponent };